import { setGlobal, getGlobal } from "reactn";
import Api from "js/core/api";

setGlobal({
    googleConnect: {
        hasGoogleAuthTokens: false,
        googleContacts: []
    }
});

export default class googleConnectorDS {
    static async connectToGoogle(auth2) {
        const { code } = await auth2.grantOfflineAccess({
            scope: "https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/admin.directory.user.readonly",
            redirect_uri: "postmessage",
            prompt: "consent"
        });

        const { id_token } = await Api.oauthCallback.get({ code });
        return !!id_token;
    }

    static async fetchGoogleContacts() {
        try {
            const results = await Api.getContacts.get();
            setGlobal({
                googleConnect: {
                    ...getGlobal().googleConnect,
                    googleContacts: results
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    static async checkGoogleAuthTokenExists() {
        const result = await Api.hasGoogleAuthTokens.get();
        setGlobal({
            googleConnect: {
                ...getGlobal().googleConnect,
                hasGoogleAuthTokens: result
            }
        });
    }
}
